import React, { FC, Fragment, useMemo } from 'react'
import { observer } from 'mobx-react'
import ProductItem from '../../../ProductItem'
import { themeMobx, decorationMobx, buyTogetherMobx } from '@mobxStore'
import { menuMobx, cartMobx } from 'restaurant'
import WaterfallAdvertItem from '@pages/menu/components/WaterfallAdvertItem'
import { filter, sortBy } from '@dt/fe-utils/dist/lodash'
import { SoldoutFoldBar } from '@cps'
import './index.scss'

// interface
interface IProps {
  category: IMenuCategory;
  type: 'classic' | 'list';
  advertMap?: { [key: string]: any[] };
}
/** 菜单容器宽度 去掉左侧导航 */
const wrapWidth = window.innerWidth - 96

const CategoryItem: FC<IProps> = ({ category, type, advertMap }) => {
  const { productNoToCntMap } = cartMobx.cartResult
  const isBuyTogether = !!Config.buyTogetherId
  const { mealDecorates } = decorationMobx
  const { no, name, desc, products } = category
  const { categories } = menuMobx
  const soldoutCnt = filter(products, (item) => item.disable).length
  const showSoldout = useMemo(() => {
    return menuMobx.openFoldSoldout === 1 && soldoutCnt > 0
  }, [products])
  const isColumn = useMemo(() => {
    return desc && (name.zhLength() > 6 || (name.zhLength() < 6 && desc.zhLength() > 12))
  }, [category])
  const _products = useMemo(() => {
    return !menuMobx.openFoldSoldout ? products : menuMobx.foldSoldoutMap[no] === true ? sortBy(products || [], (product) => product.saleCnt === 0 ? 1 : 0) : filter(products, (item) => !item.disable)
  }, [products, menuMobx.foldSoldoutMap[no]])
  const TopWaterfallAdvert = () => {
    return !!advertMap[0] && category.no === categories[0].no && (
      <>
        {
          advertMap?.[0]?.map((item, j) => (
            <WaterfallAdvertItem
              data={item}
              wrapWidth={wrapWidth}
              key={`advert_0_${j}`}
              id={`advert_0_${j}`}
              type='default'
            />
          ))
        }
      </>
    )
  }
  const WaterfallAdvert = ({ no }) => {
    return (
      <>
        {
          advertMap?.[no]?.map((item, j) => (
            <WaterfallAdvertItem
              data={item}
              key={`advert_${no}_${j}`}
              wrapWidth={wrapWidth}
              type='default'
              id={`advert_${no}_${j}`}
            />
          ))
        }
      </>
    )
  }
  return (
    <div
      className='category-list category-item'
      id={`category-item-${no}`}
      data-id={`category-${no}`}
    >
      <div className={`category-title${isColumn ? ' column' : ''}`}>
        <div className='title' style={{ fontSize: `${mealDecorates?.fontSetting?.menuCategory?.fontSize || 16}px`, fontWeight: mealDecorates?.fontSetting?.menuCategory?.fontWeight ? 700 : 500 }}>{name}</div>
        {desc && <div className='sub-title'>{desc}</div>}
      </div>
      <TopWaterfallAdvert />
      {
        _products.map((product) => {
          const count = isBuyTogether ? buyTogetherMobx.productNoToCntMapForMenu?.[product.no] || 0 : productNoToCntMap?.[product.no] || 0
          return (
            <Fragment key={product.no}>
              <ProductItem
                backgroundMode={themeMobx.data.backgroundMode}
                type={type}
                product={product}
                count={count}
                lazy
                mealDecorates={decorationMobx.mealDecorates}
                imgLoaded={menuMobx.imgLoadingMap[product.no]}
              />
              <WaterfallAdvert key={`${product.no}_advert`} no={no + product.no} />
            </Fragment>
          )
        })
      }
      {!!showSoldout && (
        <SoldoutFoldBar
          cnt={soldoutCnt}
          className='product-item'
          show={menuMobx.foldSoldoutMap?.[no] === true}
          no={no}
          from='menu'
        />
      )}
    </div>
  )
}

export default observer(CategoryItem)
